import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

// =============================================================================
// Transform Field Icons
// =============================================================================

export function TransformRotate(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "TransformRotate",
    viewBox: "0 0 24 24",
    path: (
      <>
        <path
          d="M23 4v6h-6"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <path
          d="M1 20v-6h6"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <path
          d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function TransformScale(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "TransformScale",
    viewBox: "0 0 24 24",
    path: (
      <>
        <polyline
          points="15 3 21 3 21 9"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <polyline
          points="9 21 3 21 3 15"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="21"
          y1="3"
          x2="14"
          y2="10"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="3"
          y1="21"
          x2="10"
          y2="14"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function TransformTranslate(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "TransformTranslate",
    viewBox: "0 0 24 24",
    path: (
      <>
        <polyline
          points="5 9 2 12 5 15"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <polyline
          points="9 5 12 2 15 5"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <polyline
          points="15 19 12 22 9 19"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <polyline
          points="19 9 22 12 19 15"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="2"
          y1="12"
          x2="22"
          y2="12"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <line
          x1="12"
          y1="2"
          x2="12"
          y2="22"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function TransformSkew(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "TransformSkew",
    viewBox: "0 0 24 24",
    path: (
      <>
        <path
          d="M6 2L3 22h6l3-20H6z"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <path
          d="M18 2l-3 20h6l3-20h-6z"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}

export function TransformOrigin(props: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: "TransformOrigin",
    viewBox: "0 0 24 24",
    path: (
      <>
        <line
          x1="22"
          y1="2"
          x2="11"
          y2="13"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
        <polygon
          points="22 2 15 22 11 13 2 9 22 2"
          stroke="currentColor"
          strokeWidth="2"
          className="icon-outline"
        />
      </>
    ),
  });
  return <Icon {...validateKeys(props)} />;
}
